export enum FlagCirculationArea {
  End = 'C',
  NotDeliberated = 'R',
}
